import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _startsWithInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/starts-with';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/splice';
import _lastIndexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/last-index-of';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import React__default, { useRef, useState, useCallback, useEffect } from 'react';
import classNames from 'classnames';
import styles from './92eaf70a5288baa390f98abe62f370ca7d0fa305958109435f118350410b09ae.cfe-internal.js';
import { DropdownContextProvider } from './96f486109d0d2850b21eef94a8c44cc3323a66fb525ca5574171063673f9afca.cfe-internal.js';
import DropdownButton from './e4b1ddbaf01adff19e387aec48526d0b0b2b2327998bc850542b3f4bb4eacfa4.cfe-internal.js';
import DropdownList from './38f544533ed811c651a2672712bff679b6fae971f08963b16ad2020d0643770c.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import { ChildIndexProvider } from './ChildIndexContext/c457595779a7ac9d386978c8bfe7a9c931826ac323551ee01f4fd049cfaec786.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';
import { useDidUpdate } from '../../hooks/useDidUpdate/f8ce5c85f293b5c4ca8be6bc5ac9f246003ac61cc91ab03b8814ccaab638a21a.cfe-internal.js';
import useClickOutside from '../../hooks/useClickOutside/093095b07737bf7e3954fcb01b077308dc339e5b14c18c3bec4dc276dceea639.cfe-internal.js';

var _excluded = ["className", "children", "disabled", "isInvalid", "isOpen", "private_highlightedIndex", "isMultiSelect", "onIsOpenChange", "private_onHighlightedIndexChange", "defaultValue", "value", "onChange", "id", "aria-labelledby", "aria-label", "aria-describedby", "isSearchable", "searchValue", "onSearchValueChange", "isSearchFilteringDisabled"];
var Dropdown = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _context, _ref2, _dropdownButton$props, _dropdownButton$props2, _dropdownList$props$i, _dropdownList$props;
  var className = _ref.className,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isInvalid = _ref.isInvalid,
    isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
    externalIsOpen = _ref.isOpen,
    externalHighlightedIndex = _ref.private_highlightedIndex,
    _ref$isMultiSelect = _ref.isMultiSelect,
    isMultiSelect = _ref$isMultiSelect === void 0 ? false : _ref$isMultiSelect,
    onIsOpenChange = _ref.onIsOpenChange,
    onHighlightedIndexChange = _ref.private_onHighlightedIndexChange,
    defaultValue = _ref.defaultValue,
    externalValue = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    ariaLabelledBy = _ref['aria-labelledby'],
    ariaLabel = _ref['aria-label'],
    ariaDescribedby = _ref['aria-describedby'],
    isSearchable = _ref.isSearchable,
    externalSearchValue = _ref.searchValue,
    onSearchValueChange = _ref.onSearchValueChange,
    isSearchFilteringDisabled = _ref.isSearchFilteringDisabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  var buttonRef = useRef(null);
  var listRef = useRef(null);
  var dropdownButton = /*#__PURE__*/React__default.createElement(DropdownButton, null);
  var dropdownList = /*#__PURE__*/React__default.createElement(DropdownList, null);
  var _useControllableState = useControllableState('', onSearchValueChange, externalSearchValue),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    searchValue = _useControllableState2[0],
    setSearchValue = _useControllableState2[1];
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    searchHeight = _useState2[0],
    setSearchHeight = _useState2[1];
  _forEachInstanceProperty(_context = React__default.Children).call(_context, children, function (child) {
    if ( /*#__PURE__*/React__default.isValidElement(child)) {
      switch (child === null || child === void 0 ? void 0 : child.type) {
        case DropdownButton:
          dropdownButton = child;
          break;
        case DropdownList:
          dropdownList = child;
          break;
        default:
          break;
      }
    }
  });
  var containerId = useId(id);
  var buttonId = (_ref2 = (_dropdownButton$props = (_dropdownButton$props2 = dropdownButton.props.children) === null || _dropdownButton$props2 === void 0 || (_dropdownButton$props2 = _dropdownButton$props2.props) === null || _dropdownButton$props2 === void 0 ? void 0 : _dropdownButton$props2.id) !== null && _dropdownButton$props !== void 0 ? _dropdownButton$props : dropdownButton.props.id) !== null && _ref2 !== void 0 ? _ref2 : "".concat(containerId, "-button");
  var listId = (_dropdownList$props$i = (_dropdownList$props = dropdownList.props) === null || _dropdownList$props === void 0 ? void 0 : _dropdownList$props.id) !== null && _dropdownList$props$i !== void 0 ? _dropdownList$props$i : "".concat(containerId, "-list");
  var _useControllableState3 = useControllableState(false, onIsOpenChange, externalIsOpen),
    _useControllableState4 = _slicedToArray(_useControllableState3, 2),
    isOpen = _useControllableState4[0],
    setIsOpen = _useControllableState4[1];
  var _useControllableState5 = useControllableState(defaultValue, onChange, externalValue),
    _useControllableState6 = _slicedToArray(_useControllableState5, 2),
    value = _useControllableState6[0],
    setValue = _useControllableState6[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isKeyboardUser = _useState4[0],
    setIsKeyboardUser = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedIndex = _useState6[0],
    setSelectedIndex = _useState6[1];
  var _useControllableState7 = useControllableState(-1, onHighlightedIndexChange, externalHighlightedIndex),
    _useControllableState8 = _slicedToArray(_useControllableState7, 2),
    highlightedIndex = _useControllableState8[0],
    setHighlightedIndex = _useControllableState8[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    minWidth = _useState8[0],
    setMinWidth = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    options = _useState10[0],
    setOptions = _useState10[1];
  useDidUpdate(function () {
    if (!isOpen) {
      setSearchValue('');
    }
  }, [isOpen, setSearchValue]);
  var handleClose = useCallback(function () {
    setIsOpen(false);
    setHighlightedIndex(-1);
  }, [setIsOpen, setHighlightedIndex]);
  var findOptionAndHighlight = function findOptionAndHighlight(_char) {
    var lowerCaseChar = _char.toLowerCase();
    var index = -1;
    var currentIndex = (highlightedIndex + 1) % options.length; // start at next index
    var count = 0;
    while (count < options.length) {
      var _option$label, _context2;
      var option = options[currentIndex];
      if ((_option$label = option.label) !== null && _option$label !== void 0 && _startsWithInstanceProperty(_context2 = _option$label.toLowerCase()).call(_context2, lowerCaseChar)) {
        index = currentIndex;
        break;
      }
      // increment currentIndex (wrap)
      currentIndex = (currentIndex + 1) % options.length;
      count += 1;
    }
    if (index !== -1) {
      setHighlightedIndex(index);
    }
  };
  var selectHighlightedItem = function selectHighlightedItem(e) {
    var _option$handleSelect;
    var option = options[highlightedIndex];
    option === null || option === void 0 || (_option$handleSelect = option.handleSelect) === null || _option$handleSelect === void 0 || _option$handleSelect.call(option, e);
  };
  useClickOutside([buttonRef, listRef], handleClose);
  useEffect(function () {
    var newSelectedIndex = Math.max(_findIndexInstanceProperty(options).call(options, function (option) {
      return option.isSelected;
    }), 0);
    setSelectedIndex(newSelectedIndex);
  }, [options, value]);
  var onOptionSelected = useCallback(function (newValue) {
    if (isMultiSelect) {
      setValue(function (prevValue) {
        var _context3;
        var valueArray = prevValue || prevValue === 0 ? _concatInstanceProperty(_context3 = []).call(_context3, prevValue) : [];
        var i = _findIndexInstanceProperty(valueArray).call(valueArray, function (v) {
          return v === newValue;
        });
        if (i !== -1) {
          _spliceInstanceProperty(valueArray).call(valueArray, i, 1);
        } else {
          valueArray.push(newValue);
        }
        return valueArray;
      });
    } else {
      var _buttonRef$current;
      setValue(newValue);
      handleClose();
      (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    }
  }, [isMultiSelect, handleClose, setValue]);
  var onKeyDownButton = function onKeyDownButton(e) {
    var _context4;
    setIsKeyboardUser(true);
    var newHighlightedIndex;
    if (disabled) return;
    switch (e.key) {
      case 'Enter':
      case ' ':
        // Open and focus selected option
        setIsOpen(true);
        setHighlightedIndex(selectedIndex);
        e.preventDefault(); // prevent scroll
        break;
      case 'ArrowDown':
        // Open and focus first option. This will either be the search input, or the unfiltered first option.
        setIsOpen(true);
        setHighlightedIndex(0);
        e.preventDefault(); // prevent scroll
        break;
      case 'ArrowUp':
        // Open and focus last option
        setIsOpen(true);
        newHighlightedIndex = _lastIndexOfInstanceProperty(_context4 = _mapInstanceProperty(options).call(options, function (element) {
          return element.isVisible;
        })).call(_context4, true);
        if (newHighlightedIndex !== -1) {
          setHighlightedIndex(newHighlightedIndex);
        }
        e.preventDefault(); // prevent scroll
        break;
      case 'Escape':
      case 'Tab':
        // close
        handleClose();
        break;
      default:
        break;
    }
  };
  var onKeyDownList = function onKeyDownList(e) {
    var _context5, _context6, _buttonRef$current2, _buttonRef$current3, _context7;
    setIsKeyboardUser(true);
    var newHighlightedIndex;
    if (disabled) return;
    switch (e.key) {
      case 'Enter':
      case ' ':
        // select option
        selectHighlightedItem(e);
        e.preventDefault(); // prevent scroll/button click
        break;
      case 'ArrowDown':
        // highlight next option
        newHighlightedIndex = _indexOfInstanceProperty(_context5 = _mapInstanceProperty(options).call(options, function (element) {
          return element.isVisible;
        })).call(_context5, true, highlightedIndex + 1);
        if (newHighlightedIndex !== -1) {
          setHighlightedIndex(newHighlightedIndex);
        }
        if (newHighlightedIndex !== highlightedIndex) {
          e.preventDefault(); // prevent scroll
        }
        break;
      case 'ArrowUp':
        // highlight previous option
        newHighlightedIndex = _lastIndexOfInstanceProperty(_context6 = _mapInstanceProperty(options).call(options, function (element) {
          return element.isVisible;
        })).call(_context6, true, Math.max(highlightedIndex - 1, 0));
        if (newHighlightedIndex !== -1) {
          setHighlightedIndex(newHighlightedIndex);
        }

        // scrolls first-item headers into view
        if (newHighlightedIndex === 0 && listRef.current) {
          listRef.current.scrollTop = 0;
        }
        if (newHighlightedIndex !== highlightedIndex) {
          e.preventDefault(); // prevent scroll
        }
        break;
      case 'Escape':
        // close, focus button, and don't let event bubble up
        e.stopPropagation();
        handleClose();
        (_buttonRef$current2 = buttonRef.current) === null || _buttonRef$current2 === void 0 || _buttonRef$current2.focus();
        break;
      case 'Tab':
        // close and focus next focusable element
        handleClose();
        (_buttonRef$current3 = buttonRef.current) === null || _buttonRef$current3 === void 0 || _buttonRef$current3.focus();
        break;
      case 'PageUp':
      case 'Home':
        // highlight first option. This will either be the search input, or the unfiltered first option.
        setHighlightedIndex(0);

        // scrolls first-item headers into view
        if (listRef.current) {
          listRef.current.scrollTop = 0;
        }
        e.preventDefault(); // prevent scroll
        break;
      case 'PageDown':
      case 'End':
        newHighlightedIndex = _lastIndexOfInstanceProperty(_context7 = _mapInstanceProperty(options).call(options, function (element) {
          return element.isVisible;
        })).call(_context7, true);
        // highlight last option
        if (newHighlightedIndex !== -1) {
          setHighlightedIndex(newHighlightedIndex);
        }
        e.preventDefault(); // prevent scroll
        break;
      default:
        findOptionAndHighlight(e.key);
        break;
    }
  };
  return /*#__PURE__*/React__default.createElement(DropdownContextProvider, {
    value: {
      value: value,
      isOpen: isOpen,
      buttonRef: buttonRef,
      buttonId: buttonId,
      options: options,
      isMultiSelect: isMultiSelect,
      highlightedIndex: highlightedIndex,
      selectedIndex: selectedIndex,
      minWidth: minWidth,
      setMinWidth: setMinWidth,
      setHighlightedIndex: setHighlightedIndex,
      setIsOpen: setIsOpen,
      disabled: disabled,
      isInvalid: isInvalid,
      onKeyDownButton: onKeyDownButton,
      onKeyDownList: onKeyDownList,
      onOptionSelected: onOptionSelected,
      listRef: listRef,
      listId: listId,
      ariaLabelledBy: ariaLabelledBy,
      ariaLabel: ariaLabel,
      ariaDescribedby: ariaDescribedby,
      isKeyboardUser: isKeyboardUser,
      setIsKeyboardUser: setIsKeyboardUser,
      isSearchable: isSearchable,
      isSearchFilteringDisabled: isSearchFilteringDisabled,
      searchValue: searchValue,
      setSearchValue: setSearchValue,
      searchHeight: searchHeight,
      setSearchHeight: setSearchHeight
    }
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    id: id,
    ref: ref,
    className: classNames(className, styles.container)
  }), dropdownButton, /*#__PURE__*/React__default.createElement(ChildIndexProvider, {
    items: options,
    setItems: setOptions
  }, dropdownList)));
});
var Dropdown$1 = Dropdown;

export { Dropdown$1 as default };
